<script lang="ts">
    import { onMount } from "svelte";
    import { ConfigurationManager } from "../../ConfigurationManager";
    import type { IBookingController, IGamesController } from "../../controller";
    import BookingRequestSummary from "../fragments/BookingRequestSummary.svelte";
    import { type Booking, BOOKING_STATUS } from "../../model/Booking";
    import { SLOT_TYPES, type Slot } from "../../model/Slot";
    import { DefaultErrorHandler, getMessagingService, MESSAGE_TYPE, type MessagingService } from "../../utility/ContextHelper.svelte";
    import LoadingSpinner from "../components/LoadingSpinner.svelte";
    import { getAuthInfo, type AuthInfo } from "../../utility/AccountUtility";
    import jQuery from "jquery";

    let { params = { id: undefined } } = $props();

    /**
     * The technical id of this booking request
     */
    let bookingRequestId: string = params['id'];

    let bookingController: IBookingController = ConfigurationManager.getInstance().bookingController;

    let gamesController: IGamesController = ConfigurationManager.getInstance().gamesController;

    let bookingRequest: Booking = $state();
    let slot: Slot = $state();

    let authInfo: AuthInfo = getAuthInfo();

    let msgService: MessagingService = getMessagingService();

    onMount(() => {
        bookingController.getBooking(bookingRequestId).then((v: Booking) => {
            bookingRequest = v;
            gamesController.getSlot(bookingRequest.slotId).then((vs: Slot) => {
                slot = vs;
            }).catch(DefaultErrorHandler);

        }).catch(DefaultErrorHandler);

    });

    let checkedAssets: string[] = $state([]);


    function handlerCheckboxClicked(assetId: string) {
        const idx = checkedAssets.indexOf(assetId);
        if (idx >= 0) {
            checkedAssets = checkedAssets.filter(id => id !== assetId);
        } else {
            checkedAssets = [...checkedAssets, assetId];
        }
    }


    function confirmCallback(event: Event) {
        jQuery(event.target).prop("disabled", true);

        const relevantSlots = slot.type === SLOT_TYPES.COMPLEX && slot.slots?.length
            ? slot.slots
            : [slot];

        // Validate exactly one asset is selected per slot
        const slotToAssetMap: Map<string, string> = new Map();
        for (const s of relevantSlots) {
            const slotAssets = bookingRequest.assets.filter(
                (a) => (a.refSlot ?? slot.id) === s.id
            );
            const selected = slotAssets.filter((a) => checkedAssets.indexOf(a.id) >= 0);
            if (selected.length !== 1) {
                DefaultErrorHandler(`Please select exactly one asset for slot "${s.name ?? s.id}"`);
                jQuery(event.target).prop("disabled", false);
                return;
            }
            slotToAssetMap.set(s.id, selected[0].id);
        }

        bookingController.confirmBooking(bookingRequestId, slotToAssetMap).then((booking: Booking) => {
            msgService.BoradcastMessage("Successfully booked " + booking.name, MESSAGE_TYPE.SUCCESS);
            //@ts-ignore
            window.location = "#/booking/" + booking.id;
        }).catch((err) => {
            DefaultErrorHandler(err);
            jQuery(event.target).prop("disabled", false);
        });
    }

    function cancelOrRejectBookingRequestCallback(event: Event) {
        bookingController.endBookingRequest(bookingRequestId).then(() => {
            msgService.BoradcastMessage("Succesfully canceled booking request", MESSAGE_TYPE.SUCCESS);
            bookingController.getBookingRequest(bookingRequestId).then((v: Booking) => {
                bookingRequest = v;
            }).catch(DefaultErrorHandler);
        }).catch(DefaultErrorHandler);
    }

</script>

<h2 class="text-center mb-0">Summary</h2>
<p class="text-info text-center">
    A summary of the requested booking
</p>

<LoadingSpinner loaded={bookingRequest != null && slot != null}>
    <BookingRequestSummary showStatus={true} bookingRequest="{bookingRequest}" adSlot="{slot}" showCheckMark={authInfo.isGameCompany()} keepImageCheckboxClicked={handlerCheckboxClicked} checkedItems={checkedAssets} singleSelectPerSlot={true}></BookingRequestSummary>
    {#if authInfo.isGameCompany()}
        {#if bookingRequest.status == BOOKING_STATUS.requested}
            <button class="btn btn-primary" onclick={confirmCallback}>Confirm Booking</button>
        {/if}
        {#if !bookingRequest.isCanceled()}
            <button class="btn btn-danger" onclick={cancelOrRejectBookingRequestCallback}>Reject Booking</button>        
        {/if}
    {/if}
    {#if authInfo.isAdvertiser()}
        {#if !bookingRequest.isCanceled()}
            <button class="btn btn-danger" onclick={cancelOrRejectBookingRequestCallback}>Cancel Booking</button>
        {/if}
    {/if}
</LoadingSpinner>

